import axios from 'axios';

import BaseService from '../baseService';

export default class CourseService extends BaseService {

    async postCourse(data) {
      const USER_TOKEN = localStorage.getItem('token')
      const response = await axios.post(process.env.VUE_APP_API + '/courses', data, { headers: { Authorization: `Bearer ${USER_TOKEN}` } });
      return response;
    }
    async getAllCourses() {
      const URI = '/courses';
      const response = await this.getAsync(URI);
      return response?.data;
    }
    async getMyCourses() {
      const URI = '/courses';
      const response = await this.getAsync(URI);
      return response?.data;
    }
    async  getDeletedCourses() {
      const URI = '/courses/me/deleted';
      const response = await this.getAsync(URI);
      return response?.data;
    }
    async getCourse(id) {
      const URI = `courses/me/${id}`;
      const response = await this.getAsync(URI);
      return response?.data;
    }
    async  editCourse(id, data) {
      const URI = `courses/me/${id}`;
      const response = await this.putAsync(URI, data);
      return response?.data;
    }
    async  doneLesson(id, data) {
      const URI = `/lessons/${id}`;
      const response = await this.patchAsync(URI, data);
      return response?.data;
    }
    async restoreCourse(id) {
      const URI = `courses/me/${id}/restore`;
      const response = await this.patchAsync(URI);
      return response?.data;
    } 
    async deleteCourse(id) {
      const URI = `courses/me/${id}`;
      const response = await this.deleteAsync(URI);
      return response?.data;
    }
  }